import {
  guidelinesDataTourismPolicy2023,
  tourismPolicy2023Sections,
  yojanaBannerItems,
} from "../../config/homePageUtils";
import HomeLayout from "./HomeLayout";
import Banner from "../../components/Landing/Banner";
import Section from "../../components/Landing/Section";
import Button from "../../components/common/Button";
import CapitalSubsidySection from "../../components/Landing/CapitalSubsidySection";
import { INVEST_UK_WEBSITE_URL } from "../../config/apiConfig";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import YojanaSections from "../../components/Landing/YojanaSections";
import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";

const TourismPolicy2023 = () => {
  const { image, title, description, overview } =
    yojanaBannerItems.tourismPolicy2023;
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("overview");
  const { language } = useLanguage();

  return (
    <HomeLayout>
      <Banner
        image={image}
        title={title}
        description={description}
        buttonUrl={INVEST_UK_WEBSITE_URL}
        language={language}
      />
      <YojanaSections
        options={tourismPolicy2023Sections}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        language={language}
      >
        {activeSection === "overview" && (
          <Section
            id="overview"
            title={language ? "योजना विवरण" : "Scheme Overview"}
            openByDefault={true}
            language={language}
          >
            <p>{language ? overview.hi : overview.en}</p>
          </Section>
        )}
        {activeSection === "policy-validity" && (
          <Section
            id="policy-validity"
            title={language ? "नीति की वैधता" : "Policy Validity"}
          >
            <p>
              {language
                ? "यह नीति इस नीति के लागू होने की तारीख से 7 वर्षों तक या किसी नई नीति के लागू होने तक प्रभावी रहेगी।"
                : "This Policy shall remain in effect for 7 years from the date of this policy or until a new policy supersedes it"}
            </p>
          </Section>
        )}
        {activeSection === "capital-subsidy" && (
          <CapitalSubsidySection language={language} />
        )}
        {activeSection === "guidelines" && (
          <Section
            id="detailed-scheme-section"
            title={language ? "दिशा-निर्देश" : "Guidelines"}
            spaceY4Needed={false}
          >
            <div>
              {/* Downloads Table */}
              <div className="mb-6">
                <h3 className="text-[#018f9b] font-semibold mb-2">
                  {language ? "डाउनलोड" : "Downloads"}
                </h3>

                <div className="overflow-x-auto">
                  <table className="w-full border border-gray-300 text-sm">
                    <thead className="bg-btn text-white">
                      <tr>
                        <th className="border p-2 text-white">
                          {language
                            ? "शासनादेश/गाइड लाइन्स"
                            : "Government Orders / Guidelines"}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr className="bg-white align-top">
                        {/* LEFT COLUMN */}
                        <td className="border p-3">
                          {guidelinesDataTourismPolicy2023.downloads.govt.map(
                            (item, i) => (
                              <div key={i} className="mb-2">
                                <div
                                  key={i}
                                  onClick={() =>
                                    window.open(
                                      item.file,
                                      "_blank",
                                      "noopener,noreferrer",
                                    )
                                  }
                                  className="mb-2 cursor-pointer text-blue-600 hover:underline"
                                >
                                  <span className="text-[#018f9b] mr-2 mt-1">
                                    ●
                                  </span>{" "}
                                  {language ? item.label.hi : item.label.en}
                                </div>
                              </div>
                            ),
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </Section>
        )}
      </YojanaSections>
      <section className="px-4 py-10 md:px-20 lg:px-32">
        <div className="max-w-7xl mx-auto px-0">
          <Button
            className="inline-flex items-center bg-[#018f9b] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#3e8722] transition"
            onClick={() => {
              navigate("/login");
            }}
          >
            {language ? "अभी अप्लाई करें" : "Apply Now/ Login"} →
          </Button>
        </div>
      </section>
    </HomeLayout>
  );
};

export default TourismPolicy2023;
